module.exports = __webpack_public_path__ + "static/media/eat-wisely.167430c8.jpg";